export default __webpack_public_path__ + "static/media/_domain_5.8b629089.png";